import { activityRegisterSlice } from "./slice/activity-register.slice";
import { configureStore } from "@reduxjs/toolkit";
//@ts-ignore
import { authLogReducer } from "../reducers/authLogReducer";
//@ts-ignore

//@ts-ignore
import { authReducer } from "../reducers/authReducer";
//@ts-ignore
import { cleanUpsReducer } from "../reducers/cleanUpsReducer";
//@ts-ignore
import { clientsReducer } from "../reducers/clientsReducer";
//@ts-ignore
import { collaboratorReducer } from "../reducers/collaboratorReducer";
//@ts-ignore
import { documentationReducer } from "../reducers/documentationReducer";
//@ts-ignore
import { dbUiReducer } from "../reducers/dbUiReducer";
//@ts-ignore
import { fcmReducer } from "../reducers/fcmReducer";
//@ts-ignore
import { miscReducer } from "../reducers/miscReducer";
//@ts-ignore
import { rfcReducer } from "../reducers/rfcReducer";
//@ts-ignore
import { userReducer } from "../reducers/userReducer";
// import { timeOffRequestsSlice } from "./slice/timeOffRequestSlice";
import { tasksSlice } from "./slice/taskSlice";
import { workLogSlice } from "./slice/workLogsSlice";
import { attendanceRecordsSlice } from "./slice/attendanceRecordsSlice";
import { authSlice } from "./slice/authSlice";
import { authActivitiesSlice } from "./slice/authActivitiesSlice";
import { notificationSlice } from "./slice/notificationSlice";
import { clientAuthSlice } from "./slice/clientAuthSlice";
import {
  branchSlice,
  collaboratorsSlice,
  controlledPrescriptionsSlice,
  jobSlice,
  publicHolidaysSlice,
  salaryDataSlice,
  formStatusSlice,
  weekShiftsSlice,
  timeOffRequestsSlice,
  employmentSlice,
  payrollSlice,
  commissionableServicesSlice,
  CommissionAllocationsSlice,
} from "./slice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    // @ts-ignore
    authLogs: authLogReducer,
    // @ts-ignore
    cleanups: cleanUpsReducer,
    clients: clientsReducer,

    documentation: documentationReducer,
    dbUi: dbUiReducer,
    fcm: fcmReducer,
    misc: miscReducer,
    // @ts-ignore
    rfc: rfcReducer,
    // @ts-ignore
    users: userReducer,
    timeOffRequestsReducer: timeOffRequestsSlice.reducer,
    taskReducer: tasksSlice.reducer,
    workLogsReducer: workLogSlice.reducer,
    attendanceRecordsReducer: attendanceRecordsSlice.reducer,
    authReducer: authSlice.reducer,
    authActivitiesReducer: authActivitiesSlice.reducer,
    notificationsReducer: notificationSlice.reducer,
    activityRegisterReducer: activityRegisterSlice.reducer,
    controlledPrescriptions: controlledPrescriptionsSlice.reducer,
    branches: branchSlice.reducer,
    jobs: jobSlice.reducer,
    salaryData: salaryDataSlice.reducer,
    publicHolidays: publicHolidaysSlice.reducer,
    // @ts-ignore
    // collaborator: collaboratorReducer,
    collaborator: collaboratorsSlice.reducer,
    formStatus: formStatusSlice.reducer,
    weekShifts: weekShiftsSlice.reducer,
    employments: employmentSlice.reducer,
    payrolls: payrollSlice.reducer,
    commissionableServices: commissionableServicesSlice.reducer,
    commissionAllocations: CommissionAllocationsSlice.reducer,
    clientAuth: clientAuthSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
